import styled from 'styled-components';

export interface IFullScreen {
  open: boolean;
}

export const Container = styled.div<IFullScreen>`
  display: flex;
  width: ${({ open }) => (open ? '9.5rem' : '0')};
  height: calc(100% - 5rem);
  top: 5rem;
  left: ${({ open }) => (open ? '9rem' : '2.75rem')};
  z-index: 101;
  position: absolute;
  background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
  flex-direction: column;
  border-right: 1px solid ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};

  .header {
    width: 100%;
    padding: 0.5rem;
    text-align: center;
  }
`;
